var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVendorUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 74C42.7276 74 47.4089 73.0688 51.7766 71.2596C56.1443 69.4505 60.1129 66.7987 63.4558 63.4558C66.7988 60.1129 69.4505 56.1443 71.2597 51.7766C73.0688 47.4089 74 42.7276 74 38C74 33.2724 73.0688 28.5911 71.2597 24.2234C69.4505 19.8557 66.7988 15.8871 63.4558 12.5442C60.1129 9.20124 56.1443 6.5495 51.7766 4.74034C47.4089 2.93117 42.7276 2 38 2C28.4522 2 19.2955 5.79284 12.5442 12.5442C5.79285 19.2955 2 28.4522 2 38C2 47.5478 5.79285 56.7045 12.5442 63.4558C19.2955 70.2071 28.4522 74 38 74ZM38 74C45.0431 74.0075 51.932 71.9371 57.804 68.048C57.3399 64.1803 55.4763 60.6162 52.5649 58.0283C49.6534 55.4403 45.8954 54.0074 42 54H34C30.1046 54.0074 26.3466 55.4403 23.4351 58.0283C20.5237 60.6162 18.6601 64.1803 18.196 68.048C24.0679 71.9373 30.9568 74.0077 38 74ZM50 30C50 33.1826 48.7357 36.2348 46.4853 38.4853C44.2348 40.7357 41.1826 42 38 42C34.8174 42 31.7652 40.7357 29.5147 38.4853C27.2643 36.2348 26 33.1826 26 30C26 26.8174 27.2643 23.7651 29.5147 21.5147C31.7652 19.2643 34.8174 18 38 18C41.1826 18 44.2348 19.2643 46.4853 21.5147C48.7357 23.7651 50 26.8174 50 30Z",
    stroke: "#2E2E30",
    strokeWidth: 3.55556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorUser);
export default __webpack_public_path__ + "static/media/vendorUser.154faf47bd5db297cf963d435f3987e1.svg";
export { ForwardRef as ReactComponent };